import { useContext } from 'react';
import OptimizelyContext from './OptimizelyContext';
import getOptimizelyInstance from './getOptimizelyInstance';
const noop = () => {};
const useOptimizelyTrack = () => {
  const {
    disabled,
    user: {
      id
      // TODO: Should also we pull in `attributes` here?
    } = {}
  } = useContext(OptimizelyContext);
  if (disabled) {
    return noop;
  }
  return function (eventKey, _temp) {
    let {
      userId = id,
      attributes,
      tags,
      value = tags && tags.value
    } = _temp === void 0 ? {} : _temp;
    return getOptimizelyInstance().track(eventKey, userId, attributes, {
      ...tags,
      value
    });
  };
};
export default useOptimizelyTrack;